<template lang='pug'>
//- 線上諮詢語音輸入
div(:class='$style[`cc-popbox-chat-wizard`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div.prevent-selection(:class='$style[`cc-content-title`]')
    .font-bold(:class='$style[`cc-banner-main-subtitle`]') 一鍵發問Dr.Cell，輕鬆執行任務

  div(:class='$style[`cc-chat-wizard-content`]')
    ul(:class='$style[`cc-chat-wizard-content-ul`]')
      li(v-for='item, index in chatWizardFeature' :key='index' :class='$style[`cc-chat-wizard-content-li`]')
        button(
          :aria-label='item.name'
          tabindex='0'
          :class='$style[`cc-chat-wizard-content-btn`]'
          @click='debounceStartChatWizard(item.value)') {{ item.name }}
          i(v-if='item.experimental' :class='$style[`cc-chat-wizard-content-btn-tip`]') 實驗服務

      li(:class='$style[`cc-chat-wizard-content-li`]')
        button(
          aria-label='診斷報告解說'
          tabindex='0'
          :class='$style[`cc-chat-wizard-content-btn`]'
          @click='debounceRedirect("/sideeffect/translator")') 診斷報告解說

      li(:class='$style[`cc-chat-wizard-content-li`]')
        button(
          aria-label='飲食照片分析'
          tabindex='0'
          :class='$style[`cc-chat-wizard-content-btn`]'
          @click='debounceRedirect("/sideeffect/diet")') 飲食營養分析

    div(:class='$style[`cc-chat-wizard-content-tips`]')
      span Dr.Cell 將判讀您的病歷、諮詢紀錄、ePRO數據，提供個人化的回覆

  div(:class='$style[`cc-content-controller`]')
    button.btn-black-extra(
      title='取消'
      tabindex='0'
      aria-label='取消'
      :class='$style[`cc-controller-cancel`]'
      @click='handleClosePopBox') 取消

</template>

<script>
import { mapMutations } from 'vuex';

import IconWizard from '../../icon/Wizard';
import Inputer from '../common/Input';
import { debounce } from 'debounce';
import GlobalEmitter from 'tiny-emitter/instance';

export default {
  components: {
    IconWizard,
    Inputer,
  },

  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    debounceStartChatWizard: debounce(async function(e) {
      GlobalEmitter.emit('create-wizard', { feature: e });
    }, 300),

    debounceRedirect: debounce(async function(e) {
      this.handleClosePopBox();
      this.$router.push(e).catch(() => true);
    }, 300),
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginProfile: 'user/exportUserProfile',
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginHashCode: 'user/exportUserHashCode',
  //     authJwtToken: 'user/exportUserJwtToken',
  //     consultWebSocket: 'user/exportConsultWebSocket',
  //     liffVendorHash: 'user/exportLiffVendorHash',
  //   }),
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popChatWizard.scss';
</style>
